<template>
    <div class="timer" :class="(horizontal ? 'horizontal ' : '') + statusClass">

        <div class="timer-tick">
            <i :class="statusIcon"></i>
        </div>
        <div class="timer-info">
            {{ hours }}<small>u</small> {{ minutes }}<small>m</small>
        </div>

    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            due: {
                required: true,
				type: String,
            },
			elapsed: {
				type: Number,
				default: 0
			},
			remaining: {
				type: Number,
				default: 0
			},
			isOpen: {
				type: Boolean,
				default: true
			},
			switchOn: {
				type: String,
			},
            completed: {
                type: String,
            },
            horizontal: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                now: Math.trunc((new Date()).getTime() / 1000),
                date: null,
                diff: 0,
                interval: null,
				isOfficeHour: true,
				isCompletedPastDueDate: false,
				isCompleted: false
            }
        },
        computed: {
            statusIcon() {
				if(this.isCompleted) {
					return 'fas fa-check-circle';
				}
				if (!this.isOfficeHour) {
					return 'fas fa-pause-circle';
				}
				if(this.statusClass === 'timer-danger') {
                    return 'fas fa-exclamation-circle';
                }
				if(this.diff > 0) {
					return 'fas fa-play-circle';
				}
                return 'fas fa-spinner fa-spin';
            },
            statusClass() {
				if (this.isCompleted) {
					return (this.isCompletedPastDueDate) ? 'timer-warning' : 'timer-success';
				}
                if(this.diff === false) {
                    return 'timer-light text-muted';
                }
                if(this.diff > 60 * 60 * 5) {
                    return 'timer-success';
                }
                else if(this.diff >  60 * 60 * 2) {
                    return 'timer-warning';
                }
                return 'timer-danger';
            },
            minutes() {
                return Math.trunc(this.diff / 60) % 60
            },
            hours() {
                return Math.trunc(this.diff / 60 / 60)
            }
        },
        watch: {
            now(value) {
				const switchTime = Math.trunc(Date.parse(this.switchOn.replace("-", " ")) / 1000);
				this.isOfficeHour = (this.isOpen) ? this.now < switchTime : this.now >= switchTime;

				if (this.isOfficeHour && !this.isCompleted) {
					this.diff = this.date - this.now;
				}
            },
            due() {
                this.start();
            },
            completed() {
                this.start();
            }
        },
        mounted() {
            this.start();
            this.interval = setInterval(this.calculate, 1000);
        },
        methods: {
            start() {
                if (!this.due) {
                    throw new Error("Missing props 'due'");
                }
                this.date = Math.trunc(Date.parse(this.due.replace("-", " ")) / 1000);
                if (!this.date) {
                    throw new Error("Invalid props value, correct the 'due'");
                }
				this.isCompleted = this.completed !== '';
				this.isCompletedPastDueDate = this.isCompleted && this.remaining < 0;
				this.diff = (this.isCompleted) ? this.elapsed * 60 : this.remaining * 60;

				if (this.remaining > 0) {
					this.date = new Date().getTime() / 1000 + this.remaining * 60;
				}
				this.diff = this.remaining * 60
                this.calculate();
            },
            calculate() {
                this.now = Math.trunc((new Date()).getTime() / 1000);
            }
        },
        filters: {
            twoDigits(value) {
                if ( value.toString().length <= 1 ) {
                    return '0'+value.toString()
                }
                return value.toString()
            }
        },
        destroyed() {
            clearInterval(this.interval);
        }
    }

</script>

<style lang="scss">
</style>